import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Access } from 'src/app/models/security/Access';
import { CompaniesBranchOffice } from 'src/app/models/security/CompaniesBranchOffice';
import { CompanyOffice } from 'src/app/models/security/company-office';
import { Software } from 'src/app/models/security/Software';
import { environment } from 'src/environments/environment';
import { ApiHelper } from 'src/environments/api.helper';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  readonly apiUrl: string = `${environment.API_BASE_URL_NAV_AUTHORIZATION}`
  readonly apiUrlOffline: string = `${environment.API_BASE_OFFLINE_URL_NAV_AUTHORIZATION}`
  private readonly ACCESS_STATE = '_ACCESS_STATE';
  permissionsList: number[] = [];
  apiHelper: ApiHelper

  constructor(
    public httpClient: HttpClient
  ) {
    this.apiHelper = new ApiHelper(this.apiUrl, this.apiUrlOffline, environment.offline)
  }

  get permissions() {
    const accesses: Access[] = JSON.parse(localStorage.getItem(this.ACCESS_STATE));
    Object.values(accesses).map(item => { this.permissionsList.push(item.id); });
    return this.permissionsList;
  }

  get access() {
    const accesses: Access[] = JSON.parse(localStorage.getItem(this.ACCESS_STATE));
    Object.values(accesses).map(item => { this.permissionsList.push(item.id); });
    return accesses;
  }

  getSoftwareByUser(idUser: number) {
    return this.httpClient.get<Software[]>
    (`${this.apiHelper.getApi()}/Software/GetSoftwareByUser?idUser=${idUser}`)
      .toPromise()
      .then( response => <Software[]>response)
      .catch( error => {
        return error;
      });
    }

  getCompaniesBrachOfficeSoftwareByUser(idUser: number, Option: number) {
    return this.httpClient.get<CompaniesBranchOffice[]>
    (`${this.apiHelper.getApi()}/Software/GetSoftwareCompaniesBranchOfficeByUser?idUser=${idUser}&Option=${Option}`)
      .toPromise()
      .then( response => <CompaniesBranchOffice[]>response)
      .catch( error => {
        return error;
      });
  }

  getCompanyBrachOfficesByUser(idUser: number) {
    return this.httpClient.get<CompanyOffice[]>
    (`${this.apiHelper.getApi()}/Company/GetCompanyOffices/${idUser}`).toPromise();
  }

  sendToStorage(result: Access[]) {
    localStorage.setItem(this.ACCESS_STATE, JSON.stringify(result));
  }

  removeStateAccessFromStorage() {
     localStorage.removeItem(this.ACCESS_STATE);
  }
}
